import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000;
  opacity: 0.9;
  z-index: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
`;

export const CloseButtonContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  color: #fff;
  cursor: pointer;

  svg {
    font-size: 30px;
  }
`;
